<sc-auth-page-wrapper mainTitle="Activación de cuenta">
  <div class="loader-container" auth-page-wrapper-content>
    <sc-loading></sc-loading>
  </div>
</sc-auth-page-wrapper>